import { useQuery } from '@tanstack/react-query'
import { getSubGames } from '@/api/map/game'
import { keys } from '@/api/hooks/shared/keys'

/** Lab `Account/getSubGames` — sport / table names for the selected product. */
export function useSubGames(game: string | null) {
  const gameKey = game && game !== 'all' ? game : 'all'
  return useQuery({
    queryKey: keys.subGames(gameKey),
    queryFn: () => getSubGames(gameKey),
    staleTime: 60_000,
  })
}
